import { Document } from "./document.model";
import { ActionTypes } from "./document.actions";
import { Action } from "@ngrx/store";

export interface State {
  searchQuery: string;
  documents: Document[];
  selectedDocument: Document | null;
  searching: boolean;
  loading: boolean;
  showDetails: boolean;
}

export const initialState: State = {
  searchQuery: null,
  documents: [],
  selectedDocument: new Document(),
  searching: false,
  loading: false,
  showDetails: false,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.LIST:
      return Object.assign({}, state, { searching: true });

    case ActionTypes.FILTER:
      return Object.assign({}, state, { searchQuery: action.payload });

    case ActionTypes.LIST_COMPLETE:
      return Object.assign({}, state, {
        documents: action.payload,
        searching: false,
      });

    case ActionTypes.LIST_FAIL:
      return Object.assign({}, state, { searching: false });

    case ActionTypes.LOAD:
      return Object.assign({}, state, { loading: true, showDetails: true });

    case ActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        selectedDocument: action.payload,
      });

    case ActionTypes.ADD:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.ADD_SUCCESS:
      return Object.assign({}, state, {
        documents: [...state.documents, action.payload],
        showDetails: false,
        loading: false,
      });

    case ActionTypes.ADD_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.UPDATE:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.UPDATE_SUCCESS:
      let documents = state.documents.map((document) => {
        return !document.isDefault && document.id === action.payload.id
          ? Object.assign({}, document, action.payload)
          : document;
      });

      if (action.payload.defaultDocument) {
        documents = documents.map((document) => {
          // if we just saved a default document, a new one was created on user space,
          // so we need to replace the default one with the user created one
          return document.isDefault &&
            action.payload.defaultDocument.id === document.id
            ? Object.assign({}, action.payload)
            : document;
        });
      }

      return Object.assign({}, state, {
        documents: documents,
        showDetails: false,
        loading: false,
      });

    case ActionTypes.UPDATE_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.DELETE:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.DELETE_SUCCESS:
      return Object.assign({}, state, {
        documents: state.documents.filter(
          (document) => document.id !== action.payload.id,
        ),
        showDetails: false,
        loading: false,
      });

    case ActionTypes.DELETE_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.CREATE:
      return Object.assign({}, state, {
        selectedDocument: new Document(),
        showDetails: true,
      });

    case ActionTypes.CLOSE:
      return Object.assign({}, state, {
        showDetails: false,
        selectedDocument: null,
      });

    default:
      return state;
  }
}

export const getDocuments = (state: State) =>
  state.documents
    .filter((document) => {
      if (!state.searchQuery) {
        return true;
      } else {
        const q = state.searchQuery.toLowerCase();
        return document.name.toLowerCase().indexOf(q) > -1;
      }
    })
    .sort((a, b) => {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    });
export const getSelected = (state: State) => state.selectedDocument;
export const isSearching = (state: State) => state.searching;
export const isLoading = (state: State) => state.loading;
export const getSearchQuery = (state: State) => state.searchQuery;
export const getShowDetails = (state: State) => state.showDetails;



// WEBPACK FOOTER //
// /app/src/app/core/store/document/document.reducer.ts